import { ProcessDraftAssignmentSchema } from '../../entities/process-draft';
import { EntityOrSuggestionRefSchema } from '../../entities/entity-suggestion';
/**
 * PATCH /api/v2/process/:id/draft/assignments/:stableStepId — request
 * Assignments carry only assignee + input + helpers — no task content.
 * `assignedTo` carries the {@link EntityOrSuggestionRefSchema} union so a
 * suggested team/system can be assigned (bound to a pending suggestion that
 * approval later resolves), and is nullable so callers can send `null` to
 * clear the assignee (distinguishing "omit the field" from "unassign").
 *
 * The response envelope carries the updated assignment plus any upstream
 * nodes whose successors were recomputed.
 */ export const UpdateDraftAssignmentRequestSchema = ProcessDraftAssignmentSchema.pick({
    assignedTo: true,
    assignedToModel: true,
    inputs: true,
    helpers: true,
    whoElseDoesThis: true,
    generatedName: true,
    generatedDescription: true
}).partial().extend({
    assignedTo: EntityOrSuggestionRefSchema.nullable().optional()
});

//# sourceMappingURL=update-draft-assignment.schema.js.map